import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useLanguage } from '@/contexts/LanguageContext';

export const useServerTags = () => {
  const { language } = useLanguage();

  return useQuery({
    queryKey: ['server-tags', language],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('server_tags')
        .select('id, name, description, color, name_fr, name_en, name_es, description_fr, description_en, description_es')
        .order('name');

      if (error) throw error;

      // Compute localized display fields while keeping canonical name for logic
      const localized = (data || []).map((t: any) => {
        const displayName =
          language === 'en' ? (t.name_en || t.name || t.name_fr || t.name_es) :
          language === 'es' ? (t.name_es || t.name || t.name_fr || t.name_en) :
          (t.name_fr || t.name || t.name_en || t.name_es);
        const displayDescription =
          language === 'en' ? (t.description_en || t.description || t.description_fr || t.description_es) :
          language === 'es' ? (t.description_es || t.description || t.description_fr || t.description_en) :
          (t.description_fr || t.description || t.description_en || t.description_es);
        const searchTerms = [
          t.name, t.name_fr, t.name_en, t.name_es,
          t.description, t.description_fr, t.description_en, t.description_es
        ]
          .filter(Boolean)
          .join(' ') 
          .toLowerCase();
        return { ...t, displayName, displayDescription, searchTerms };
      });

      return localized;
    },
  });
};
